<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="job_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.job_date"
        name="job_date"
        v-bind="schema.fields.job_date"
        :form-state="formState"
        disable-mobile
        hide-time
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="customer"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.customer"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="customer"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.customer"
        allow-add
        store-name="Customer"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <customer-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></customer-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.address"
        :form-state="formState"
        name="address"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.address"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="suburb"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.suburb"
        :form-state="formState"
        name="suburb"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.suburb"
      ></o-text-field>
    </o-widget-wrapper>

     <o-widget-wrapper
      :schema="schema"
      name="area"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.area"
        :items="optionCodeAreaItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeAreaWorking"
        name="area"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.area"
        allow-add
        store-name="CodeArea"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-area-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-area-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="pump"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.pump"
        :items="optionPumpItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionPumpWorking"
        name="pump"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.pump"
        allow-add
        store-name="Pump"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <pump-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></pump-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="linehand"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.linehand"
        :items="optionEmployeeItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionEmployeeWorking"
        name="linehand"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.linehand"
        allow-add
        store-name="Employee"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <employee-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></employee-form>
        </template>
      </o-select>
    </o-widget-wrapper>

     <o-widget-wrapper
      :schema="schema"
      name="on_hold"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.on_hold"
        :form-state="formState"
        name="on_hold"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.on_hold"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="confirmed"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.confirmed"
        :form-state="formState"
        name="confirmed"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.confirmed"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="comments"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-textarea
        v-model="item.comments"
        :form-state="formState"
        name="comments"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.comments"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="invoice_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-button
        v-model="item.invoice_date"
        name="invoice_date"
        v-bind="schema.fields.invoice_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        title="Invoiced"
      >
      </o-date-button>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supervisor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.supervisor"
        :items="optionSupervisorItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionSupervisorWorking"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
        allow-add
        store-name="Supervisor"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <supervisor-form
            in-modal
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
          ></supervisor-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="cubic_metres"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.cubic_metres"
        :form-state="formState"
        name="cubic_metres"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.cubic_metres"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="job_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.job_type"
        :items="optionCodeJobTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeJobTypeWorking"
        name="job_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job_type"
        allow-add
        store-name="CodeJobType"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-job-type-form
            in-modal
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
          ></code-job-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="concrete_time"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.concrete_time"
        name="concrete_time"
        disable-mobile
        v-bind="schema.fields.concrete_time"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-date
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supplier"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.supplier"
        :items="optionSupplierItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionSupplierWorking"
        name="supplier"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supplier"
        allow-add
        store-name="Supplier"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <supplier-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></supplier-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="notes"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-notes-table
        v-model="item.notes"
        model-name="JobNote"
        :validator="$v.item.notes"
        :form-state="formState"
        :level="level + 1"
        :label="schema.fields.notes.label"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :server-errors="_se.notes"
        who-field="who"
        when-field="created_date"
      >
      </o-notes-table>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="files"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-files-table
        v-model="item.files"
        model-name="JobFile"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :file-types="optionCodeFileTypeItems"
        :file-types-working="optionCodeFileTypeWorking"
        :other-id="item.id"
        other-name="job_file"
        :validator="$v.item.files"
        :form-state="formState"
        :label="schema.fields.files.label"
        :server-errors="_se[schema.fields.files.name]"
        :level="level + 1"
        who-field="who"
        when-field="created_date"
      >
      </o-files-table>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";

import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as PumpForm } from "../../pump/components/ItemForm";
import { default as SiteContactForm } from "../../site_contact/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as CodeJobTypeForm } from "../../code_job_type/components/ItemForm";
import { default as SupplierForm } from "../../supplier/components/ItemForm";
import ODateButton from "../../../vue-ocom/components/forms/fields/ODateButton";
import { default as EmployeeForm } from "../../employee/components/ItemForm";
import { default as CodeAreaForm } from "../../code_area/components/ItemForm";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Job"),
    CreateCodeTableFetchMixin([
      "Customer",
      "Pump",
      "SiteContact",
      "Supervisor",
      "CodeJobType",
      "Supplier",
      "User",
      "CodeFileType",
      "Employee",
      "CodeArea",
    ]),
  ],
  components: {
    ODateButton,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OFilesTable,
    ONotesTable,

    CustomerForm,
    PumpForm,
    SiteContactForm,
    SupervisorForm,
    CodeJobTypeForm,
    SupplierForm,
    EmployeeForm,
    CodeAreaForm,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Job, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
